// extracted by mini-css-extract-plugin
module.exports = {"breakpointDesktop":"1024px","pixel":"promo-block_pixel__MgGGt","content":"promo-block_content__7r9RO common_content__WGpQ_","beforeHeader":"promo-block_beforeHeader__RbFIY"};